import { AgTechFormContext } from "@agtech/core/forms/AgTechFormContext";
import { AgTechFormReadOnlyTextControl } from "@agtech/web/components/Forms/Controls/AgTechFormReadOnlyTextControl";
import { AgTechFormTextAreaControl } from "@agtech/web/components/Forms/Controls/AgTechFormTextAreaControl";
import { AgTechFormRow } from "@agtech/web/components/Forms/Layout/AgTechFormRow";
import { AgTechFormSection } from "@agtech/web/components/Forms/Layout/AgTechFormSection";
import { AgTechMoneyFormatter } from "@agtech/web/utilities/AgTechUtilities";
import _ from "lodash";
import { SaleInvoiceDialogFormContext, SaleInvoiceDialogFormData } from "../InvoiceCreationDialog";
import AgTechFormBody from "@agtech/web/components/Forms/Layout/AgTechFormBody";
import { calculateInvoiceTotal } from "@sales/data/invoicing/InvoicingData";
import { getContactFullName } from "@agtech/data/contacts/ContactData";
import InvoiceChangeLotsGrid from "../../../components/grids/InvoiceChangeLotsGrid";
import { buildGridEntitySelectionIndex } from "@agtech/web/components/Grids/AgTechGridEntities";
import { Index } from "@agtech/core/utilities/AgTechUtilities";

const InvoiceReviewAndCompletePage = (props: {
    formContext: AgTechFormContext<SaleInvoiceDialogFormData, SaleInvoiceDialogFormContext>
}) => {
    const invoiceSubmissionData = props.formContext.entity;
    const invoiceContextData = props.formContext.context;

    const invoiceContact = props.formContext.context.contactDetails.contact;

    // Map selected credits to their counterparts in the dialog context. This is to ensure
    // that any credits that may be been updated are reflected in the invoice totals.
    const invoiceCredits = Object.keys(invoiceSubmissionData.appliedCredits)
        .map(key => invoiceContextData.contactDetails.credits[key]);

    // Do the same for InvoiceModifiers for the same reason
    const invoiceInvoiceModifiers = Object.keys(invoiceSubmissionData.appliedInvoiceModifiers)
        .map(key => invoiceContextData.saleInvoiceModifiers[key]);

    const invoiceTotals = calculateInvoiceTotal({
        selectedLots: invoiceSubmissionData.selectedLots,
        appliedCredits: invoiceCredits,
        appliedInvoiceModifiers: invoiceInvoiceModifiers,
    });

    return (
        <AgTechFormBody>
            <AgTechFormSection header="Invoice Information">
                <AgTechFormRow>
                    <div className='row-based tall pr-6 container'>
                        <div className='mb-auto'>
                            <AgTechFormReadOnlyTextControl
                                entityType={invoiceSubmissionData}
                                caption='Bidder Number'
                                value={() => invoiceSubmissionData.bidderNumber ? invoiceSubmissionData.bidderNumber : 'N/A'}
                                controlStyles={{ width: 100 }}
                            />
                        </div>
                    </div>
                    <AgTechFormTextAreaControl
                        entityType={invoiceSubmissionData}
                        caption='Contact information'
                        readonly={true}
                        value={data => `${getContactFullName(invoiceContact)} ${invoiceContact.ranchName ? ' - ' + invoiceContact.ranchName : ''}\n${invoiceContact.emailAddress}${invoiceContact.phoneNumber ? ' | ' + invoiceContact.phoneNumber : ''}\n\n${invoiceContact.address}\n${invoiceContact.city}, ${invoiceContact.stateAbbreviation} ${invoiceContact.zip}`}
                        width={100}
                        rows={5}
                        resizable={false}
                        styles={{ lineHeight: '20px' }}
                    />
                </AgTechFormRow>
            </AgTechFormSection>
            <AgTechFormSection header='Invoice summary'>
                <AgTechFormRow>
                    <AgTechFormReadOnlyTextControl
                        entityType={invoiceSubmissionData}
                        caption='Lots sold'
                        value={e => AgTechMoneyFormatter.format(invoiceTotals.lotPurchaseTotal)}
                        classes='snug'
                    />
                    <h1 className='pt-4 font-semibold text-lg tall centered flex'>-</h1>
                    <AgTechFormReadOnlyTextControl
                        entityType={invoiceSubmissionData}
                        caption='Chargs and discounts Given'
                        value={e => AgTechMoneyFormatter.format(invoiceTotals.appliedInvoiceModifiersTotal)}
                        classes='snug'
                    />
                    <h1 className='pt-4 font-semibold text-lg tall centered flex'>-</h1>
                    <AgTechFormReadOnlyTextControl
                        entityType={invoiceSubmissionData}
                        caption='Credits Applied'
                        value={e => AgTechMoneyFormatter.format(invoiceTotals.appliedCreditsTotal)}
                        classes='snug'
                    />
                    <h1 className='pt-4 font-semibold text-lg tall centered flex'>=</h1>
                    <AgTechFormReadOnlyTextControl
                        entityType={invoiceSubmissionData}
                        caption='Invoice Amount'
                        value={e => AgTechMoneyFormatter.format(invoiceTotals.invoiceTotal)}
                        classes='snug'
                    />
                </AgTechFormRow>
            </AgTechFormSection>
            <AgTechFormSection
                header={`Invoice lots (${invoiceSubmissionData.selectedLots.length})`}
                classes='flexed'
                bodyClasses='flexed py-3'
            >
                <InvoiceChangeLotsGrid
                    contactId={props.formContext.context.contactDetails.contact.id}
                    availableLots={buildGridEntitySelectionIndex({
                        entities: props.formContext.entity.selectedLots,
                        isSelected: () => true
                    })}
                    isReadonly={true}
                />
            </AgTechFormSection>
        </AgTechFormBody>
    )
}

export default InvoiceReviewAndCompletePage;